<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("登入") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">Life Nutrition</div>
            </div>

            <md-card-content>
              <form novalidate class="md-layout" @submit.prevent="validateUser">
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="login_error.username">
                        <label for="name">{{ $t("用戶") }}</label>
                        <md-input
                          name="username"
                          id="username"
                          v-model="username"
                          @focus="clearError('username')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="login_error.password">
                        <label for="name">{{ $t("密碼") }}</label>
                        <md-input
                          name="password"
                          id="password"
                          v-model="password"
                          type="password"
                          @focus="clearError('password')"
                        />
                      </md-field>
                    </div>
                  </div>
                </div>
              </form>

              <div class="md-layout md-gutter">
                <div class="md-layout-item md-small-size-100 container-checkout_btn">
                  <md-button type="submit" class="md-primary" @click="onClickLogin">{{ $t("登入") }}</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      eventHub: window.eventHub,
      login_error:{
        username : false,
        password : false,
      },
    };
  },
  methods: {
    clearError (){

    },

    async onClickLogin() {
      if (this.username == "" || this.password == "") {
        alert("Please enter username & password");
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "member_login.php",
        data: {
          username: this.username,
          password: this.password
        }
      });

      if (response.data.status == "success") {

        localStorage.setItem('member_id', response.data.user.id);
        localStorage.setItem('member_token', response.data.user.token);
        localStorage.setItem('user_type', response.data.user.user_type);

        this.$store.state.member_id = response.data.member_id;

        eventHub.$emit("user_login");

        this.$router.replace("/");
      } else {
        alert("用戶/密碼錯誤 請重新輸入");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.root-container {
  padding-top: 150px;
}
</style>